import React, { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Grid,
  Card,
  CardContent,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { dashboardIcon, images } from "../../config/images";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import SideMenu from "../../components/SideMenu/SideMenu";
import "../Dashboard/Dashboard.css";
import AreaChart from "./AreaChart";
import translations from "../../config/language";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const Dashboard = ({isSidebarOpen}) => {

  const language = process.env.REACT_APP_LANGUAGE;

  const chartData = {
    labels: [
      "10:00",
      "11:00",
      "12:00",
      "13:00",
      "14:00",
      "15:00",
      "16:00",
      "17:00",
      "18:00",
    ],
    datasets: [
      {
        label: "Performance Metrics",
        data: [0, 20, 60, 80, 40, 50, 70, 30, 40],
        fill: true,
        backgroundColor: "rgba(0, 204, 153, 0.2)",
        borderColor: "rgba(0, 204, 153, 1)",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  const dashboardCards = [
    {
      icon: dashboardIcon.totalFarmer,
      count: 1250,
      label: translations[language].totalFarmersRegistered,
      color: "#80546D",
    },
    {
      icon: dashboardIcon.totalFarmer,
      count: 350,
      label: translations[language].pendingFarmerApprovals,
      color: "#D8856C",
    },
    {
      icon: dashboardIcon.totalTask,
      count: 24,
      label: translations[language].taskAssignmentNotifications,
      color: "#348B81",
    },
    {
      icon: dashboardIcon.totalData,
      count: 15680,
      label: translations[language].totalDataCollectors,
      color: "#533F6F",
    },
  ];
  // const isSidebarOpen = localStorage.getItem('isSidebarOpen') === "false";
  return (
    // <Box
    //   sx={{ minHeight: "100vh", display: "flex", backgroundColor: "#F4F5FA" }}
    // >

    <Box sx={{ flex: 1 }}>
      <Grid container spacing={3} sx={{ marginTop: "0px" }}>
        {console.log("sdhujkfd dashboard", isSidebarOpen)}
        {dashboardCards.map((card, index) => (
          <Grid item xs={12}
            sm={isSidebarOpen == false ? 6 : 12}
            md={3}
            key={index}
            className="pt-0 grid-box"
            sx={{ padding: "12px", }}
          >
            <Card
              sx={{ backgroundColor: card.color, color: "#fff", height: "183px" }}
              className="dashboard-card"
            >
              <CardContent className="dashboard-card-content" sx={{ height: "100%" }}>
                <Box
                  display="flex"
                  alignItems="center"
                  className="ml-4 justify-content-between"
                >
                  <Box>
                    <img src={card.icon} alt="" />
                  </Box>
                  <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                    {card.count}
                  </Typography>
                </Box>
                <Box className="ml-3">
                  <Typography variant="h6" >
                    {card.label.split(" ")[0]}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: "bold",
                      letterSpacing: "0.5px",
                      fontSize: "18px",
                    }}
                    className="DASHBOARD-P"
                  >
                    {card.label.split(" ").slice(1).join(" ")}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Box mt={4}>
        <Box className="chart-wrap">
          <Box className="d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap" }}>
            <Typography variant="h6">
             {translations[language].performanceMetricsOfDataCollectors}
            </Typography>
            <FormControl size="small" sx={{ minWidth: 120 }}>
              <Select defaultValue="Today" MenuProps={{ disableScrollLock: true }}>
                <MenuItem value="Today">{translations[language].today}</MenuItem>
                <MenuItem value="This Week">{translations[language].thisWeek}</MenuItem>
                <MenuItem value="This Month">{translations[language].thisMonth}</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Box className="mt-5">
            <div style={{ width: "100%" }}>
              <AreaChart />
            </div>
          </Box>
        </Box>
      </Box>
    </Box>
    // </Box>
  )
};

export default Dashboard;
